/* eslint-disable jsx-a11y/alt-text */
import "./style/detail.css"
// hook
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
// img
// @ts-ignore
import delivertIcon from './../../assets/media/global/static_pdp_delivery_today.svg'
// icons
import {
    IconStarFilled,
    IconListSearch,
    IconBubbleText,
    IconShoppingBag,
    IconShare,
    IconChartArcs,
    IconCash,
    IconClock,
    IconStar,
    IconX,
    IconCheck,
    IconGitCompare,
    IconSettings,
    IconLockCheck,
    IconChevronRightPipe
} from '@tabler/icons-react';
// link
import { useParams, Link } from "react-router";
// controller
import { showProduct } from "../../services/client/products/showProduct";
import useGetData from "../../hook/getData";
// setting
import { ProductsSettings } from "../../features/swiperOptions/swiperOptions";
// component
import ProductsCard from "../../components/products/products";
// useState
import { useEffect, useState } from "react";
import { splitNumber } from "../../features/splitNumber/splitNumber";
import { FreeMode, Thumbs } from "swiper/modules";
// @ts-ignore
import Cookies from "js-cookie";
// form
import { useForm } from "react-hook-form";
import { onError } from "../../features/error/error";
import { toast } from "react-toastify";
import { toastOptions } from "../../features/toast/toast";
import { useMutation } from "@tanstack/react-query";
import { SendComment } from "../../services/panel/comments/sendComments";
import Heart from "../../components/heart/heart";
import { useCart } from "../../context/cartContext";
import { SendCart } from "../../services/panel/cart/sendCart";
// image zoom
import { GetCarts } from "../../services/panel/cart/getCart";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import parse from 'html-react-parser';
import CompareProducts from "../../components/products/compareProducts";
import CompareFooter from "../../components/compare/compare";
import { CompareProvider } from "../../context/CompareContext";

const Detail = () => {
    const params = useParams();
    const { data, isLoading } = useGetData(['detail', params.id], showProduct);
    console.log(data)
    const [thumbsSwiper, setThumbsSwiper] = useState<any>();
    let [checkSale, setSale] = useState<any>('');
    let [price, setPrice] = useState<any>('0');
    let [day, setDay] = useState<any>('');
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedId, setId] = useState<any>('');
    const [colorSite, setColor] = useState<any>('');
    const [selectedQuan, setQuan] = useState<any>('');
    const [selectedPesent, setPersent] = useState<any>('');
    const { register, handleSubmit, setValue, watch }: any = useForm<any>();
    const [hovered, setHovered] = useState<number | null>(null);
    const [activeImage, setActiveImage] = useState(data?.product?.primary_image);
    // @ts-ignore
    const images = [data?.product?.primary_image, ...(data?.product?.images || []).map((img: any) => img.image)];
    const selectedRate = watch('rate', 0);
    useEffect(() => {
        window.scrollTo(0, 0);
        setQuan(data?.productVariations[0]?.quantity)
        setId(data?.productVariations[0]?.id)
        if (data?.product?.has_variation !== 0) {
            setPrice(data?.productVariations[0]?.sale_price ? data?.productVariations[0]?.sale_price : data?.productVariations[0]?.price)
            setPersent(data?.productVariations[0]?.percent_sale)
            setSale(data?.productVariations[0]?.is_sale)
            const dateFrom = new Date(data?.productVariations[0]?.date_on_sale_from);
            const dateTo = new Date(data?.productVariations[0]?.date_on_sale_to);
            const diffMs = dateTo.getTime() - dateFrom.getTime();
            const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
            setDay(diffDays)
        }
        else {
            setPrice(data?.product?.sale_price ? data?.product?.sale_price : data?.product?.price)
            if (data?.product?.percent_sale) {
                setPersent(data?.product?.percent_sale)
            }
            if (data?.product?.sale_price) {
                setSale(true)
                const dateFrom = new Date(data?.product?.date_on_sale_from);
                const dateTo = new Date(data?.product?.date_on_sale_to);
                const diffMs = dateTo.getTime() - dateFrom.getTime();
                const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                setDay(diffDays)
            }
        }
        setSelectedValue(data?.productVariations[0]?.value);
        const normalizedColor = data?.productVariations[0]?.color_code?.startsWith('#') ? data?.productVariations[0]?.color_code : `#${data?.productVariations[0]?.color_code}`;
        setColor(normalizedColor);
    }, [data?.product?.date_on_sale_from, data?.product?.date_on_sale_to, data?.product?.has_variation, data?.product?.price, data?.product?.sale_price, data?.productVariations])
    const filterSale = (price: any, sale: any, from: any, to: any, value: any, valueId: any, quan: any, persent: any) => {
        setSale(sale)
        setPrice(price)
        setSelectedValue(value)
        const dateFrom = new Date(from);
        const dateTo = new Date(to);
        const diffMs = dateTo.getTime() - dateFrom.getTime();
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        setDay(diffDays)
        setId(valueId)
        setQuan(quan)
        setPersent(persent)
    }
    const mutation = useMutation({
        mutationFn: SendComment,
        onSuccess: () => {
            toast.success('نظر شما ثبت شد(پس از تایید ادمین نمایش داده خواهد شد)', toastOptions);
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    const onSubmit = (items: any) => {
        let newData = items;
        newData.id = data?.product?.id;
        mutation.mutate(newData)
    };
    const shareProduct = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    text: data.product.title,
                    url: window.location.href,
                });
            } catch (error) {
                console.error('Error sharing content:', error);
            }
        } else {
            console.error('Error sharing content:');
        }
    };
    const { refetch: cartRefetch } = useGetData(['carts'], GetCarts)
    const { addToCart } = useCart();
    const Cartmutation = useMutation({
        mutationFn: SendCart,
        onSuccess: () => {
            cartRefetch();
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    const addToCarts = (product_id: number, qtybutton: number, variation_id: number, quantity: number) => {
        if (Cookies.get('agent_token')) {
            let data = {
                items: [
                    {
                        product_id: product_id,
                        variation_id: variation_id,
                        quantity: 1,
                    }
                ]
            }
            Cartmutation.mutate(data);
        }
        else {
            addToCart({
                product_id: product_id,
                variation_id: variation_id,
                qty: 1,
                quantity: quantity,
                item_image: data?.product?.primary_image,
                item_name: data?.product?.name,
                item_price: price,
                item_var_name: selectedValue,
            });
        }
    }

    function isColorLight(color: string) {
        if (!color) return false;
        const hex = color.replace('#', '');
        if (hex.length !== 6) return false;
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 155;
    }


    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const currentIndex = images.indexOf(activeImage);
            if (event.key === "ArrowRight") {
                const prevIndex = (currentIndex - 1 + images.length) % images.length;
                setActiveImage(images[prevIndex]);
            } else if (event.key === "ArrowLeft") {
                const nextIndex = (currentIndex + 1) % images.length;
                setActiveImage(images[nextIndex]);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [activeImage, images]);


    return (
        <>
            {isLoading ? (
                <>
                    <div className="container h-100 mt-5">
                        <div className="row h-100 justify-content-center py-5 align-items-center">
                            <div className="col-md-6 text-center">
                                <img className="acband-price-icon animate-logo" src={require('../../assets/media/logo/final.png')} />
                                <p className="fw-bold mt-3">
                                    در حال بارگذاری..
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <section className="bg-white app project-app">
                        <div className="container">
                            <div className="row overflow-x-hidden">
                                <div id="star-box" className="col-lg-9 col-md-12 col-12 mt-5">
                                    <div className="card card-body border-1 rounded rounded-4">
                                        <div className="row overflow-x-hidden">
                                            <div className="col-lg-7 col-md-6 col-12 order-md-0 order-1">
                                                <h1 className="detail-product-name line-25 fw-bold font-large mb-0 mt-1">
                                                    {data?.product?.name}
                                                </h1>
                                                <div className="d-md-flex align-items-center d-none align-items-center justify-content-between mt-2">
                                                    <div>
                                                        <span className="font-medium-lg">
                                                            {data?.product?.en_name ? data?.product?.en_name : null}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row overflow-x-hidden gy-5 pe-md-4 mt-md-1 mt-1">
                                                    <div className="col-md-12 mt-1">
                                                        {data?.product?.has_variation !== 0 ? (<><hr /></>) : null}
                                                        <div className="detail-color fw-bold">
                                                            {data?.product?.has_variation !== 0 ? (
                                                                <>
                                                                    <p>{data?.productVariations ? data?.productVariations[0]?.attribute?.name : ''} : {selectedValue}</p>
                                                                </>
                                                            ) : null}
                                                            <div className="d-flex">
                                                                {data?.product?.has_variation !== 0 ? (
                                                                    <>
                                                                        {data?.productVariations?.map((item: any, index: number) => {
                                                                            const backgroundColor =
                                                                                index === 0
                                                                                    ? colorSite
                                                                                    : item.color_code?.startsWith('#')
                                                                                        ? item.color_code
                                                                                        : `#${item.color_code}`;

                                                                            const showLightColor = isColorLight(backgroundColor);

                                                                            return (
                                                                                <div key={index} className="px-2">
                                                                                    <div className="d-flex justify-content-center">
                                                                                        <Tippy content={item.value}>
                                                                                            <div>
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    className="btn-check"
                                                                                                    name="radio"
                                                                                                    id={`input-${index}`}
                                                                                                    checked={item.value === selectedValue}
                                                                                                    onChange={() =>
                                                                                                        filterSale(
                                                                                                            item.sale_price ? item.sale_price : item.price,
                                                                                                            item.is_sale,
                                                                                                            item.date_on_sale_from,
                                                                                                            item.date_on_sale_to,
                                                                                                            item.value,
                                                                                                            item.id,
                                                                                                            item.quantity,
                                                                                                            item.percent_sale
                                                                                                        )
                                                                                                    }
                                                                                                    value={item.value}
                                                                                                    autoComplete="off"
                                                                                                />
                                                                                                <label
                                                                                                    htmlFor={`input-${index}`}
                                                                                                    className="btn-check-radio py-1"
                                                                                                    style={{ backgroundColor }}
                                                                                                >
                                                                                                    {item.value === selectedValue && (
                                                                                                        <IconCheck size={20} color={showLightColor ? 'black' : 'white'} />
                                                                                                    )}
                                                                                                </label>
                                                                                            </div>
                                                                                        </Tippy>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </>
                                                                ) : (
                                                                    null
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="fw-bold d-md-block d-none">
                                                            <hr />
                                                            <p className="font-medium-lg">ویژگی های اصلی :</p>
                                                            <div className="box-site p-3 rounded-4">
                                                                <ul className="list-group list-group-flush">
                                                                    {data?.productAttributes?.map((item: any, index: number) => (
                                                                        <>
                                                                            {data?.categoryMainAttributes?.map((main: any) => (
                                                                                <>
                                                                                    {item.attribute_id === main.id && item.value != 0 ? (
                                                                                        <li style={{ padding: '12px 0' }} className="list-group-item px-0">
                                                                                            <div className="d-flex align-items-center w-100">
                                                                                                <span className="text-site font-medium mb-0">
                                                                                                    {item.attribute.name} :
                                                                                                </span>
                                                                                                <span className="text-split ms-2 font-medium fw-bold mb-0">
                                                                                                    {item.value}
                                                                                                </span>
                                                                                            </div>
                                                                                        </li>
                                                                                    ) : null}
                                                                                </>
                                                                            ))}
                                                                        </>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5 col-md-6 col-12 order-md-1 order-0 mb-md-0 mb-4 position-relative">
                                                <div className="row row-cols-md-6 row-cols-4 justify-content-center mb-2">
                                                    <div className="col">
                                                        <div className="card-body px-0 border-0 shadow-sm d-flex justify-content-center w-100 rounded-4 text-center">
                                                            <Heart id={data?.product?.id} />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="card-body px-0 border-0 shadow-sm d-flex justify-content-center w-100 rounded-4 text-center" onClick={() => shareProduct()}>
                                                            <IconShare size={18} />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="card-body px-0 border-0 shadow-sm d-flex justify-content-center w-100 rounded-4 text-center" data-bs-toggle="modal" data-bs-target="#compare-modal">
                                                            <IconGitCompare size={18} />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="card-body px-0 border-0 shadow-sm d-flex justify-content-center w-100 rounded-4 text-center">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="ltr mb-0">
                                                                    <div className="d-flex justify-content-center align-content-center mb-0">
                                                                        <IconStarFilled style={{ marginTop: '1px' }} color="#F9AE2E" size={12} />
                                                                        <p className="font-medium ms-1 mb-0">
                                                                            {data?.product?.average_rate}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="product-img">
                                                    <div className="img-detail-main d-flex align-items-center justify-content-center">
                                                        {data?.product?.images ? (
                                                            <Swiper
                                                                loop={true}
                                                                spaceBetween={10}
                                                                navigation={true}
                                                                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                                                modules={[FreeMode, Thumbs]}
                                                                className="mySwiper2"
                                                            >
                                                                <SwiperSlide>
                                                                    <img
                                                                        onClick={() => setActiveImage(data?.product?.primary_image)}
                                                                        className="w-full rounded project-banner-img"
                                                                        data-bs-toggle="modal" data-bs-target="#images-modal"
                                                                        src={data?.product?.primary_image} />
                                                                </SwiperSlide>
                                                                {data?.product?.images?.map((image: any, index: number) => (
                                                                    <>
                                                                        <SwiperSlide key={index + 'sliderTop'}>
                                                                            <img
                                                                                onClick={() => setActiveImage(image.image)}
                                                                                data-bs-toggle="modal" data-bs-target="#images-modal" className="w-full rounded project-banner-img" src={image.image} />
                                                                        </SwiperSlide>
                                                                    </>
                                                                ))}
                                                            </Swiper>
                                                        ) : null}
                                                    </div>
                                                    {data?.product?.images ? (
                                                        <Swiper
                                                            onSwiper={setThumbsSwiper}
                                                            loop={true}
                                                            spaceBetween={10}
                                                            slidesPerView={4}
                                                            freeMode={true}
                                                            watchSlidesProgress={true}
                                                            modules={[FreeMode, Thumbs]}
                                                            className="mySwiper mt-3"
                                                        >
                                                            <SwiperSlide>
                                                                <img data-bs-toggle="modal" data-bs-target="#images-modal" className="img-detail-far-img img-fluid p-2" src={data?.product?.primary_image} />
                                                            </SwiperSlide>
                                                            {data?.product?.images?.map((image: any, index: number) => (
                                                                <>
                                                                    <SwiperSlide key={index + 'sliderTop'}>
                                                                        <img
                                                                            onClick={() => setActiveImage(image.image)}
                                                                            data-bs-toggle="modal" data-bs-target="#images-modal" className="img-detail-far-img img-fluid p-2"
                                                                            src={image.image} alt="product" />
                                                                    </SwiperSlide>
                                                                </>
                                                            ))}
                                                        </Swiper>
                                                    ) : null}
                                                </div>
                                                <div className="modal fade" id="images-modal">
                                                    <div className="modal-dialog modal-dialog-centered modal-xl">
                                                        <div className="modal-content px-md-3">
                                                            <div className="modal-header justify-content-between">
                                                                <h6 className="fw-bold text-site mb-0">تصاویر رسمی</h6>
                                                                <IconX data-bs-dismiss="modal" />
                                                            </div>
                                                            <div className="modal-body">
                                                                <p className="detail-product-name text-split mb-0 mt-1">
                                                                    {data?.product?.name}
                                                                </p>
                                                                <div className="mobile d-md-none d-block">
                                                                    <div className="img-detail-main d-flex align-items-center justify-content-center">
                                                                        {data?.product?.images ? (
                                                                            <Swiper
                                                                                loop={true}
                                                                                spaceBetween={10}
                                                                                navigation={true}
                                                                                keyboard={{ enabled: true }}
                                                                                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                                                                modules={[FreeMode, Thumbs]}
                                                                                className="mySwiper2"
                                                                            >
                                                                                <SwiperSlide>
                                                                                    <img className="w-full rounded project-banner-img" src={data?.product?.primary_image} />
                                                                                </SwiperSlide>
                                                                                {data?.product?.images?.map((image: any, index: number) => (
                                                                                    <>
                                                                                        <SwiperSlide key={index + 'sliderTop'}>
                                                                                            <img className="w-full rounded project-banner-img" src={image.image} />
                                                                                        </SwiperSlide>
                                                                                    </>
                                                                                ))}
                                                                            </Swiper>
                                                                        ) : null}
                                                                    </div>
                                                                    {data?.product?.images ? (
                                                                        <Swiper
                                                                            onSwiper={setThumbsSwiper}
                                                                            loop={true}
                                                                            spaceBetween={10}
                                                                            slidesPerView={4}
                                                                            freeMode={true}
                                                                            keyboard={{ enabled: true }}
                                                                            watchSlidesProgress={true}
                                                                            modules={[FreeMode, Thumbs]}
                                                                            className="mySwiper mt-3"
                                                                        >
                                                                            <SwiperSlide>
                                                                                <img data-bs-toggle="modal" data-bs-target="#images-modal" className="img-detail-far-img img-fluid p-2" src={data?.product?.primary_image} />
                                                                            </SwiperSlide>
                                                                            {data?.product?.images?.map((image: any, index: number) => (
                                                                                <>
                                                                                    <SwiperSlide key={index + 'sliderTop'}>
                                                                                        <img className="img-detail-far-img img-fluid p-2"
                                                                                            src={image.image} alt="product" />
                                                                                    </SwiperSlide>
                                                                                </>
                                                                            ))}
                                                                        </Swiper>
                                                                    ) : null}
                                                                </div>
                                                                <div className="d-md-block d-none">
                                                                    <div className="row my-4">
                                                                        <div className="col-md-7 order-md-0 order-1">
                                                                            <div className="img-detail-main d-flex align-items-center justify-content-center">
                                                                                <div className="row gy-3 mt-3 w-100">
                                                                                    {images.map((img: string, index: number) => (
                                                                                        <div key={index} className="col-md-3 col-4">
                                                                                            <img
                                                                                                src={img}
                                                                                                className={`img-detail-far-img w-100 img-fluid p-2 ${img === activeImage ? "border-primary" : "border-secondary"}`}
                                                                                                style={{ cursor: "pointer", borderWidth: "2px" }}
                                                                                                onClick={() => setActiveImage(img)}
                                                                                                alt={`thumbnail-${index}`}
                                                                                            />
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-5 order-md-1 order-0">
                                                                            <img
                                                                                className="w-100 rounded project-banner-img project-banner-img-div"
                                                                                style={{ height: '350px !important' }}
                                                                                src={activeImage}
                                                                                alt="عکس اصلی"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-12 col-12 mt-5 position-relative">
                                    <div className="card card-body border-1 rounded rounded-4">
                                        {data?.product?.has_variation !== 0 ? (
                                            <>
                                                {data?.productVariations.length > 0 ? (
                                                    <>
                                                        {checkSale ? (
                                                            <div className="offer-detail-suggest rounded rounded-4 px-4 mb-2 d-flex align-items-center justify-content-between">
                                                                <p className="offer-detail-suggest-child mb-2">شگفتانه</p>
                                                                <p className="offer-detail-suggest-child2 mb-2">
                                                                    <IconClock size={14} className="me-1" />
                                                                    {day}
                                                                    روز
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            null
                                                        )}
                                                    </>
                                                ) : (
                                                    <div style={{ backgroundColor: '#FFCDD2', color: 'black' }} className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                        <p className="offer-detail-suggest-child mb-2">ناموجود</p>
                                                        <p className="offer-detail-suggest-child2 mb-2">ارس کام</p>
                                                    </div>
                                                )}
                                            </>
                                        ) : data?.product?.quantity !== 0 ? (
                                            <>
                                                {checkSale ? (
                                                    <div className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                        <p className="offer-detail-suggest-child mb-2">شگفتانه</p>
                                                        <p className="offer-detail-suggest-child2 mb-2">
                                                            <IconClock size={14} className="me-1" />
                                                            {day}
                                                            روز
                                                        </p>
                                                    </div>
                                                ) : null}
                                            </>
                                        ) :
                                            (
                                                <>
                                                    <div style={{ backgroundColor: '#FFCDD2', color: 'black' }} className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                        <p className="offer-detail-suggest-child mb-2">ناموجود</p>
                                                        <p className="offer-detail-suggest-child2 mb-2">ارس کام</p>
                                                    </div>
                                                </>
                                            )
                                        }
                                        <div className="modal fade" id="card-modal-project">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content">
                                                    <div className="modal-header justify-content-between">
                                                        <h6 className="text-site fw-bold mb-0">
                                                            کالا به سبد خرید اضافه شد
                                                        </h6>
                                                        <IconX data-bs-dismiss="modal" />
                                                        <button className="d-none" hidden id="close-card-modal"></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="row gy-3">
                                                            <div className="col-3">
                                                                <img className="img-detail-far-img img-fluid p-2" src={data?.product?.primary_image} />
                                                            </div>
                                                            <div className="col-9">
                                                                <span className="font-medium-lg">
                                                                    {data?.product?.name}
                                                                </span>
                                                                <p className="me-2 text-muted text-end mt-4">
                                                                    <span className="fw-bold me-1">
                                                                        {splitNumber(price)}
                                                                    </span>
                                                                    تومان
                                                                    {selectedPesent && <span className="text-danger badge bg-danger text-light ms-3 fw-bold mb-0">{selectedPesent}%</span>}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button onClick={() => {
                                                            document.getElementById('close-card-modal')!.click();
                                                            window.open('/cart', '_self')
                                                        }} className="btn w-100 btn-primary py-3">
                                                            مشاهده سبد خرید
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card card-body p-1 px-3 border-0 shadow-sm">
                                            <div className="d-flex justify-content-between align-items-center py-3 border-bottom pb-2">
                                                <div className="form-check">
                                                    <input className="form-check-input" checked type="checkbox"></input>
                                                    <label className="form-check-label font-medium mb-0 ms-2">گارانتی اصل 24 ماهه</label>
                                                </div>
                                                <span className="font-medium">به کالا اضافه شد</span>
                                            </div>
                                            <p className="card-text font-medium line-25 mb-2 text-muted mt-3 d-flex justify-content-between align-items-center">
                                                جزئیات بیشتر :
                                                <Link to="/qa" className="text-site text-decoration-none">
                                                    (کلیک کنید)
                                                </Link>
                                            </p>
                                        </div>
                                        <div className="mt-3 rounded rounded-3 box-site">
                                            <ul className="list-group font-medium">
                                                <li className="list-group-item px-0">
                                                    <IconShoppingBag size={20} className="me-1 text-site" />
                                                    فروشگاه ارس کام
                                                </li>
                                                <li className="list-group-item px-0 my-2">
                                                    <IconSettings size={20} className="me-1 text-site" />
                                                    ارزیابی عملکرد :  عالی
                                                </li>
                                                <li className="list-group-item px-0">
                                                    <IconLockCheck size={20} className="me-1 text-site" />
                                                    گارانتی اصلی 24 ماهه
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="d-md-flex d-none justify-content-end align-content-end mt-2 pt-2">
                                            <p className="me-2">
                                                <span className="fw-bold me-1">
                                                    {splitNumber(price)}
                                                </span>
                                                تومان
                                                {selectedPesent && <span className="text-danger badge bg-danger text-light ms-2 fw-bold mb-0">{selectedPesent}%</span>}
                                            </p>
                                        </div>
                                        <div className="d-md-grid d-none">
                                            {data?.product?.has_variation !== 0 ? (
                                                <>
                                                    <button disabled={data?.productVariations.length <= 0} data-bs-toggle="modal" data-bs-target="#card-modal-project" onClick={() => addToCarts(data?.product?.id, 1, selectedId, selectedQuan)} className="btn btn-primary">افزودن به سبد خرید</button>
                                                </>
                                            ) : (
                                                <>
                                                    <button disabled={data?.product.quantity === 0} data-bs-toggle="modal" data-bs-target="#card-modal-project" onClick={() => addToCarts(data?.product?.id, 1, selectedId, selectedQuan)} className="btn btn-primary">افزودن به سبد خرید</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="box-site mt-3 rounded-4 px-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="texts">
                                                <p className="font-medium-lg mb-1">
                                                    ارسال امروز
                                                </p>
                                                <Link className="text-site  font-medium-lg text-decoration-none" to={'/delivery'}>
                                                    جزئیات بیشتر :
                                                </Link>
                                            </div>
                                            <img src={delivertIcon} alt="send" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="detail-list-info mt-5 w-100 container">
                            <div className="row flex-scroll w-100">
                                <div className="col-md-3 col-6">
                                    <div className="list-detail-parA-parent d-flex justify-content-center">
                                        <IconListSearch className="list-detail-iA" />
                                        <p className="list-detail-parA">بخش بندی محصول :</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-6">
                                    <a href="#des-part" className="text-decoration-none">
                                        <div className="d-flex justify-content-center">
                                            <p className="list-detail-par">توضیحات محصول</p>
                                            <IconChartArcs className="list-detail-i" />
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-3 col-6">
                                    <a href="#ability-part" className="text-decoration-none">
                                        <div className="d-flex justify-content-center">
                                            <p className="list-detail-par">ویژگی های محصول</p>
                                            <IconCash className="list-detail-i" />
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-3 col-6">
                                    <a href="#comment-bar" className="text-decoration-none">
                                        <div className="d-flex justify-content-center">
                                            <p className="list-detail-par">نظرات </p>
                                            <IconBubbleText className="list-detail-i" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9">
                                    <div id="description" className="container mt-3">
                                        <div className="row overflow-x-hidden">
                                            <div id="des-part" className="col-12">
                                                <div className="collapse collapse-des-short show">
                                                    <div className="detail-text-info" >
                                                        <div className="d-flex w-100 justify-content-center align-content-center">
                                                            <div className="line-detail"></div>
                                                            <p className="detail-text-info-p text-center mt-3">توضیحات محصول</p>
                                                            <div className="line-detail"></div>
                                                        </div>
                                                        <p className="detail-text-info-child line-30 card-text mb-1" style={{ maxHeight: '210px', overflow: 'hidden' }}>
                                                            {parse(data?.product?.description)}
                                                        </p>
                                                        <a href={'.collapse-des-short'} data-bs-toggle="collapse" className={" mb-2 font-medium-lg line-30 card-text text-start text-site text-decoration-none d-block"}>
                                                            بیشتر...
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="collapse collapse-des-short">
                                                    <div className="detail-text-info" >
                                                        <div className="d-flex w-100 justify-content-center align-content-center">
                                                            <div className="line-detail"></div>
                                                            <p className="detail-text-info-p text-center mt-3">توضیحات محصول</p>
                                                            <div className="line-detail"></div>
                                                        </div>
                                                        <p className="detail-text-info-child line-30 card-text mb-1">
                                                            {parse(data?.product?.description)}
                                                        </p>
                                                        <a href={'.collapse-des-short'} data-bs-toggle="collapse" className={"info-t mb-2 font-medium-lg line-30 card-text text-end text-site text-decoration-none d-block"}>
                                                            بستن...
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12" id="ability-part">
                                                <div className="d-flex w-100 justify-content-center align-content-center">
                                                    <div className="line-detail"></div>
                                                    <p className="detail-text-info-p text-center mt-3">ویژگی های محصول </p>
                                                    <div className="line-detail"></div>
                                                </div>
                                                <div className="collapse collapse-var-long show">
                                                    <div className="row overflow-x-hidden g-3">
                                                        {data?.productAttributes?.map((item: any, index: number) => (
                                                            <>
                                                                {index < 4 && item.value != 0 ? (
                                                                    <div className="col-12">
                                                                        <div className="topic-detail-text-parent w-100 p-3">
                                                                            <p className="topic-detail-text font-medium-lg mb-0">
                                                                                {item.attribute.name}
                                                                            </p>
                                                                            <p className="topic-detail-text-child font-medium text-split mb-0">
                                                                                {item.value}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ) : null}
                                                            </>
                                                        ))}
                                                        <a href={'.collapse-var-long'} data-bs-toggle="collapse" className={" mb-2 font-medium-lg line-30 card-text text-start text-site text-decoration-none d-block"}>
                                                            بیشتر...
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="collapse collapse-var-long">
                                                    <div className="row overflow-x-hidden g-3">
                                                        {data?.productAttributes?.map((item: any) => (
                                                            <>
                                                                {item.value != 0 ? (
                                                                    <>
                                                                        <div className="col-12">
                                                                            <div className="topic-detail-text-parent w-100 p-3">
                                                                                <p className="topic-detail-text font-medium-lg mb-0">
                                                                                    {item.attribute.name}
                                                                                </p>
                                                                                <p className="topic-detail-text-child font-medium text-split mb-0">
                                                                                    {item.value}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : null}
                                                            </>
                                                        ))}
                                                        <a href={'.collapse-var-long'} data-bs-toggle="collapse" className={"info-t mb-2 font-medium-lg line-30 card-text text-end text-site text-decoration-none d-block"}>
                                                            بستن...
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="comment-bar" className="container mt-3 pt-3">
                                        <div className="d-flex w-100 justify-content-center align-content-center">
                                            <div className="line-detail"></div>
                                            <div className="detail-text-info-p d-flex px-3 justify-content-between align-items-center">
                                                <p className="text-center my-0">نظرات کاربران</p>
                                                {Cookies.get('agent_token') ? (
                                                    <>
                                                        <span className="text-site" data-bs-toggle="modal" data-bs-target="#comment-modal">
                                                            ثبت نظر
                                                            <IconChevronRightPipe size={16} />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span data-bs-toggle="modal" data-bs-target="#agent" className="text-site">
                                                            ثبت نظر
                                                            <IconChevronRightPipe size={16} />
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                            <div className="line-detail"></div>
                                        </div>
                                        <div className="row">
                                            {data?.comments?.map((item: any) => (
                                                <>
                                                    <div className="col-md-4 mb-4">
                                                        <div className="card card-body border-1">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className="card-title fw-bold">
                                                                    <span>
                                                                        {item.user.name}
                                                                    </span>
                                                                    <span className="ms-2">
                                                                        {item.user.lastName}
                                                                    </span>
                                                                </p>
                                                                <div className="d-flex align-content-center align-items-center">
                                                                    <IconStarFilled color="#F9AE2E" size={12} />
                                                                    <p className="font-medium ms-1 mt-1 mb-0">
                                                                        {item?.rate?.rate}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <p className="card-text fw-bold font-medium">
                                                                {item.text}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div style={{ top: '160px' }} className="card mt-4 position-sticky card-body border-1 rounded rounded-4">
                                        {data?.product?.has_variation !== 0 ? (
                                            <>
                                                {data?.productVariations.length > 0 ? (
                                                    <>
                                                        {checkSale ? (
                                                            <div className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                                <p className="offer-detail-suggest-child mb-2">شگفتانه</p>
                                                                <p className="offer-detail-suggest-child2 mb-2">
                                                                    <IconClock size={14} className="me-1" />
                                                                    {day}
                                                                    روز
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            null
                                                        )}
                                                    </>
                                                ) : (
                                                    <div style={{ backgroundColor: '#FFCDD2', color: 'black' }} className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                        <p className="offer-detail-suggest-child mb-2">ناموجود</p>
                                                        <p className="offer-detail-suggest-child2 mb-2">ارس کام</p>
                                                    </div>
                                                )}
                                            </>
                                        ) : data?.product?.quantity !== 0 ? (
                                            <>
                                                {checkSale ? (
                                                    <div className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                        <p className="offer-detail-suggest-child mb-2">شگفتانه</p>
                                                        <p className="offer-detail-suggest-child2 mb-2">
                                                            <IconClock size={14} className="me-1" />
                                                            {day}
                                                            روز
                                                        </p>
                                                    </div>
                                                ) : null}
                                            </>
                                        ) :
                                            (
                                                <>
                                                    <div style={{ backgroundColor: '#FFCDD2', color: 'black' }} className="offer-detail-suggest px-4 mb-2 d-flex align-items-center justify-content-between">
                                                        <p className="offer-detail-suggest-child mb-2">ناموجود</p>
                                                        <p className="offer-detail-suggest-child2 mb-2">ارس کام</p>
                                                    </div>
                                                </>
                                            )
                                        }
                                        <div className="modal fade" id="card-modal-project">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content">
                                                    <div className="modal-header justify-content-between">
                                                        <h6 className="text-site fw-bold mb-0">
                                                            کالا به سبد خرید اضافه شد
                                                        </h6>
                                                        <IconX data-bs-dismiss="modal" />
                                                        <button className="d-none" hidden id="close-card-modal"></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="row gy-3">
                                                            <div className="col-3">
                                                                <img className="img-detail-far-img img-fluid p-2" src={data?.product?.primary_image} />
                                                            </div>
                                                            <div className="col-9">
                                                                <span className="font-medium-lg">
                                                                    {data?.product?.name}
                                                                </span>
                                                                <p className="me-2 text-muted text-end mt-4">
                                                                    <span className="fw-bold me-1">
                                                                        {splitNumber(price)}
                                                                    </span>
                                                                    تومان
                                                                    {selectedPesent && <span className="text-danger badge bg-danger text-light ms-2 fw-bold mb-0">{selectedPesent}%</span>}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button onClick={() => {
                                                            document.getElementById('close-card-modal')!.click();
                                                            window.open('/cart', '_self')
                                                        }} className="btn w-100 btn-primary py-3">
                                                            مشاهده سبد خرید
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card card-body p-1 px-3 border-0 shadow-sm">
                                            <div className="d-flex justify-content-between align-items-center py-3 pb-2">
                                                <img src={data?.product?.primary_image} alt="primary-img" className="primary-img img-fluid" />
                                                <span className="font-medium fw-bold">
                                                    {data?.product?.name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mt-3 rounded rounded-3 box-site">
                                            <ul className="list-group font-medium">
                                                <li className="list-group-item px-0">
                                                    <IconShoppingBag size={20} className="me-1 text-site" />
                                                    فروشگاه ارس کام
                                                </li>
                                                <li className="list-group-item px-0 my-2">
                                                    <IconSettings size={20} className="me-1 text-site" />
                                                    ارزیابی عملکرد :  عالی
                                                </li>
                                                <li className="list-group-item px-0">
                                                    <IconLockCheck size={20} className="me-1 text-site" />
                                                    گارانتی اصلی 24 ماهه
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="d-md-flex d-none justify-content-end align-content-end mt-2 pt-2">
                                            <p className="me-2">
                                                <span className="fw-bold me-1">
                                                    {splitNumber(price)}
                                                </span>
                                                تومان
                                                {selectedPesent && <span className="text-danger badge bg-danger text-light ms-3 fw-bold mb-0">{selectedPesent}%</span>}
                                            </p>
                                        </div>
                                        <div className="d-md-grid d-none">
                                            {data?.product?.has_variation !== 0 ? (
                                                <>
                                                    <button disabled={data?.productVariations.length <= 0} data-bs-toggle="modal" data-bs-target="#card-modal-project" onClick={() => addToCarts(data?.product?.id, 1, selectedId, selectedQuan)} className="btn btn-primary">افزودن به سبد خرید</button>
                                                </>
                                            ) : (
                                                <>
                                                    <button disabled={data?.product.quantity === 0} data-bs-toggle="modal" data-bs-target="#card-modal-project" onClick={() => addToCarts(data?.product?.id, 1, selectedId, selectedQuan)} className="btn btn-primary">افزودن به سبد خرید</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white py-5 pb-3">
                            <div className="container">
                                <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <h6 className="fw-bold h5 mb-0">محصولات مشابه</h6>
                                </div>
                                <div className="new-products">
                                    {data?.sameProducts ? (
                                        <Swiper
                                            {...ProductsSettings}
                                        >
                                            {data?.sameProducts?.map((product: any) => (
                                                <SwiperSlide key={product.id + 'products'}>
                                                    <ProductsCard count={product.quantity} rate={product.average_rate} price={product?.price} has_variation={product.has_variation} id={product.id} slug={product.slug} name={product.name} primary_image={product.primary_image} description={product.description} quantity_check={product.quantity_check} />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </section >
                    <div className="modal fade" id="comment-modal">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header justify-content-between">
                                    <h6 className="text-site fw-bold mb-0">کامنت</h6>
                                    <IconX data-bs-dismiss="modal" />
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSubmit(onSubmit, onError)}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-site">
                                                امتیاز شما :
                                            </span>
                                            <div className="d-flex ltr">
                                                {[1, 2, 3, 4, 5].map((star) => {
                                                    const isFilled = hovered ? star <= hovered : star <= selectedRate;
                                                    const Icon = isFilled ? IconStarFilled : IconStar;
                                                    return (
                                                        <button
                                                            type="button"
                                                            key={star}
                                                            onClick={() => setValue('rate', star)}
                                                            onMouseEnter={() => setHovered(star)}
                                                            onMouseLeave={() => setHovered(null)}
                                                            className="btn-white font-medium text-warning btn px-1"
                                                        >
                                                            <Icon size={20} />
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <fieldset className="form-floating mt-3">
                                            <textarea className="form-control" placeholder="نظر خود را بنویسید"
                                                {...register('text', { required: 'فیلد کامنت الزامی است' })}
                                            ></textarea>
                                            <label className="form-label">نظر شما</label>
                                        </fieldset>
                                        <input type="hidden" {...register('rate', { required: 'امتیاز دادن الزامی است' })} />
                                        <button disabled={mutation.isPending} className="btn btn-primary mt-3">
                                            {mutation.isPending ? 'درحال ارسال ...' : 'ثبت نظر'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CompareProvider mainProductSlug={params.id}>
                        <div className="modal fade" id="compare-modal">
                            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                                <div className="modal-content px-3">
                                    <div className="modal-header justify-content-between">
                                        <h6 className="mb-0 text-site fw-bold">مقایسه کالا</h6>
                                        <IconX data-bs-dismiss="modal" />
                                    </div>
                                    <div className="modal-body">
                                        {data?.sameProducts ? (
                                            <div className="row gy-4">
                                                {data?.sameProducts?.map((product: any) => (
                                                    <div className="col-md-3" key={product.id + "products"}>
                                                        <CompareProducts
                                                            slug={product.slug}
                                                            id={product.id}
                                                            name={product.name}
                                                            primary_image={product.primary_image}
                                                            quantity_check={product.quantity_check}
                                                            price={product?.price}
                                                            count={product?.quantity}
                                                            has_variation={product?.has_variation}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="modal-footer border-0">
                                        <button hidden className="d-none" id="close-compare" data-bs-dismiss="modal"></button>
                                        <CompareFooter />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CompareProvider>
                    <section className="d-md-none d-inline-block mobile-menu d-flex justify-content-center position-relative">
                        <div
                            className="header-mobile fixed-bottom py-2 d-md-none d-inline-block position-fixed shadow shadow-lg">
                            <div className="p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-grid">
                                        {data?.product?.has_variation !== 0 ? (
                                            <>
                                                <button disabled={data?.productVariations.length <= 0} data-bs-toggle="modal" data-bs-target="#card-modal-project" onClick={() => addToCarts(data?.product?.id, 1, selectedId, selectedQuan)} className="btn btn-primary">افزودن به سبد خرید</button>
                                            </>
                                        ) : (
                                            <>
                                                <button disabled={data?.product.quantity === 0} data-bs-toggle="modal" data-bs-target="#card-modal-project" onClick={() => addToCarts(data?.product?.id, 1, selectedId, selectedQuan)} className="btn btn-primary">افزودن به سبد خرید</button>
                                            </>
                                        )}
                                    </div>
                                    <div className="d-flex justify-content-end align-content-end mt-2 pt-2">
                                        <p className="me-2">
                                            <span className="fw-bold me-1">
                                                {splitNumber(price)}
                                            </span>
                                            تومان
                                            {selectedPesent && <span className="text-danger badge bg-danger text-light ms-2 fw-bold mb-0">{selectedPesent}%</span>}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )
            }
        </>
    )
}
export default Detail;